import * as core from '../../../../../../../core'

import { query } from './edit-proposal-domain-row.query'

export const RESOURCE = {
  payload: {
    alias: 'edit.proposal.domain.row',
    description: 'Modal used to edit domains associated with a proposal',
    name: 'Edit Proposal Domain Row',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
